import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../../../api/queryKeys'

export function useRemoveGroups () {
  const queryClient = useQueryClient()

  return useMutation({
    onMutate: async (groupIds) => {
      await queryClient.cancelQueries({ queryKey: [QUERY_KEYS.searchGroups] })

      const prevGroups = queryClient.getQueryData([QUERY_KEYS.searchGroups], { exact: false })
      const groups = prevGroups.data.filter((group) => !groupIds.includes(group.groupId))

      queryClient.setQueryData([QUERY_KEYS.searchGroups], groups)

      return { prevGroups }
    },
    onError: (_, __, context) => {
      queryClient.setQueryData([QUERY_KEYS.searchGroups], context.prevGroups)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.searchGroups] })
    }
  })
}

export function useAddGroups () {
  const queryClient = useQueryClient()

  return useMutation({
    onMutate: async (groups) => {
      await queryClient.cancelQueries({ queryKey: [QUERY_KEYS.searchGroups] })

      const prevGroups = queryClient.getQueryData([QUERY_KEYS.searchGroups], { exact: false })
      const newGroups = [...prevGroups.data, ...groups]

      queryClient.setQueryData([QUERY_KEYS.searchGroups], newGroups)

      return { prevGroups }
    },
    onError: (_, __, context) => {
      queryClient.setQueryData([QUERY_KEYS.searchGroups], context.prevGroups)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.searchGroups] })
    }
  })
}
